import type { PickerUser } from '~/pages/backoffice/admin/sessions/components/ParticipantPicker'
import { STAFF_ROLES } from '~/helpers/auth/staff-roles'
import { userDisplayName } from '~/helpers/users/display-name'

type ListedUser = PickerUser & { role?: { name: string } | null }

/**
 * Les comptes proposés comme formateurs d'un parcours : les admins et
 * formateurs de la liste chargée, plus ceux déjà affectés.
 *
 * Les affectés comptent même absents de la liste : un formateur ne voit pas les
 * admins de l'organisation (`visible-roles.ts` côté API), et sans eux, enregistrer
 * le formulaire retirerait en silence l'admin qui anime le parcours.
 */
export function trainerCandidates(users: readonly ListedUser[], assigned: readonly PickerUser[]): PickerUser[] {
  const byId = new Map<string, PickerUser>()
  for (const user of users) {
    if (user.role && (STAFF_ROLES as readonly string[]).includes(user.role.name)) byId.set(user.id, user)
  }
  for (const trainer of assigned) {
    if (!byId.has(trainer.id)) byId.set(trainer.id, trainer)
  }
  // Même ordre que le filtre « formateur » de la liste (`sessionTrainerOptions`).
  return [...byId.values()].sort((a, b) => userDisplayName(a).localeCompare(userDisplayName(b)))
}
